import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';

export interface PipelineNodeRelationship {
  id: string;
  parent_node_id: string;
  child_node_id: string;
  name: string;
  description: string;
  child_foreign_key_name: string;
  parent_lookup_logic_gate: string;
  parent_lookups: Array<{
    parent_field_id: string;
    child_field_id: string;
  }>;
  denormalized_fields?: Array<{
    parent_field_id: string;
    output_field_name: string;
  }>;
  issue_orphan_records?: number;
  issue_ambiguous_records?: number;
  taxonomic_id?: string;
  marked_deleted?: boolean;
}

export type ListRecordsResponse<T> = {
  records: T[];
  total_pages?: number;
  total_records?: number;
};

export function usePipelineNodeRelationships() {
  return useQuery<PipelineNodeRelationship[]>({
    queryKey: ['pipeline-node-relationships'],
    queryFn: async () => {
      const results = await ApiService.getInstance().request(
        'GET',
        '/pipelinenoderelationships'
      ) as ListRecordsResponse<PipelineNodeRelationship>;
      // Filter out deleted relationships
      return results.records.filter(rel => !rel.marked_deleted);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

